import React, { useState, useCallback } from 'react'
import { Modal, Button, Tabs, Tab } from 'react-bootstrap'
import styles from './CompanySettings.module.css'
import ChannelSettings from './ChannelSettings/ChannelSetting'
import AgentsSettings from './AgentsSettings/AgentsSettings'
import CallsSettings from './CallsSettings/CallsSettings'
import CallBackSettings from './CallBackSettings/CallBackSettings'
import ContactSettings from './ContactSettings/ContactSettings'
import GroupsSettings from './GroupsSettings/GroupsSetting'
// import SourceSettings from './SourceSettings/SourceSettings'
import { useTranslation } from "react-i18next";
import DialListSettings from './DialListSettings/DialListSettings'

const CompanySettings = (props) => {
    const appAccess = props.companyDetails?.appAccess
    const [t] = useTranslation('common')
    const [activeTabState, setActiveState] = useState(`${appAccess !== 'DIALER' ? 'Chat' : 'Dialer'}`)  //Chat,Dialer,Users,SourceData,DialList,CallBack
    const [saveAndRestartBtnActiveState, setSaveAndRestartBtnActiveState] = useState(false)

    const onHide = props.onHide
    const handleTabSelected = useCallback((newTab) => {
        setActiveState(newTab)
    }, [])
    const onHideMiddleware = useCallback(() => {
        setSaveAndRestartBtnActiveState(false)
        onHide()
    }, [onHide])

    return (
        <Modal
            // {...props}
            show={props.show}
            onHide={onHideMiddleware}
            size="xl"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            className={styles.modalStyle}
            dialogClassName={styles['my-modal']}
        >
            <Modal.Header >
                <Modal.Title id="contained-modal-title-vcenter">
                    {t('Settings')}
                </Modal.Title>
            </Modal.Header>
            <Modal.Body className={styles.modalBodyStyle}>
                <Tabs transition={false} id="controlled-tab-example"
                    activeKey={activeTabState}
                    onSelect={handleTabSelected}
                    className={styles.cusTabs}
                >
                    {appAccess !== 'DIALER' && <Tab tabClassName={styles.cusTab} eventKey="Chat" title={t('Messages')}>
                        <ChannelSettings
                            onAutoSendTempMsgUpdateClicked={props.onAutoSendTempMsgUpdateClicked}
                            onTempMsgAdd={props.onTempMsgAdd}
                            onTempMsgDelete={props.onTempMsgDelete}
                            tempmsgs={props.tempmsgs}
                            channelsettings={props.channelsettings}
                            botSettings={props.botSettings}
                            generalSettings={props.generalSettings}
                            setsettings={props.setsettings}
                            onAutoSendTempMsgDeleteClicked={props.onAutoSendTempMsgDeleteClicked}
                            onSaveClicked={props.onUpdateSettingsBtnClicked}
                            setSaveAndRestartBtnActiveState={setSaveAndRestartBtnActiveState}
                        />
                    </Tab>}
                    <Tab tabClassName={styles.cusTab} eventKey="Dialer" title={t('Calls')}>
                        <CallsSettings
                            setSettings={props.setsettings}
                            callssetting={props.callssetting}
                            setSaveAndRestartBtnActiveState={setSaveAndRestartBtnActiveState}
                        />
                    </Tab>
                    <Tab tabClassName={styles.cusTab} eventKey="Users" title={t('users')}>
                        <AgentsSettings
                            avatarImg={props.avatarImg}
                            agentsList={props.agentsList}
                            setSettings={props.setsettings}
                            permissionType={props.permissionType}
                            setSaveAndRestartBtnActiveState={setSaveAndRestartBtnActiveState}
                            listOfOnlineAgents={props.listOfOnlineAgents}
                        />
                    </Tab>
                    {appAccess !== 'DIALER' && <Tab tabClassName={styles.cusTab} eventKey="Groups" title={t((props.groupSetting?.type || 'Group') + 's')}>
                        <GroupsSettings
                            agentsList={props.agentsList}
                            company_groupList={props.company_groupList}
                            listOfOnlineAgents={props.listOfOnlineAgents}
                            groupSetting={props.groupSetting}
                            setsettings={props.setsettings}
                            setSaveAndRestartBtnActiveState={setSaveAndRestartBtnActiveState}
                        />
                    </Tab>}
                    <Tab tabClassName={styles.cusTab} eventKey="DialList" title={t('DialList')}>
                        <DialListSettings
                            setSettings={props.setsettings}
                            setSaveAndRestartBtnActiveState={setSaveAndRestartBtnActiveState}
                            dialListSettings={props.dialListSettings}
                        />
                    </Tab>
                    <Tab tabClassName={styles.cusTab} eventKey="CallBack" title={t('Call Back')}>
                        <CallBackSettings
                            setSettings={props.setsettings}
                            callBackSetting={props.callBackSetting}
                            setSaveAndRestartBtnActiveState={setSaveAndRestartBtnActiveState}
                        />
                    </Tab>
                    <Tab tabClassName={styles.cusTab} eventKey="Contact" title={t('Contacts')}>
                        <ContactSettings
                            setSettings={props.setsettings}
                            generalSettings={props.generalSettings}
                            setSaveAndRestartBtnActiveState={setSaveAndRestartBtnActiveState}
                        />
                    </Tab>
                </Tabs>
            </Modal.Body>
            <Modal.Footer >
                <Button onClick={props.onUpdateSettingsBtnClicked} disabled={!saveAndRestartBtnActiveState} variant="success" >{t('Save and restart')}</Button>
                <Button className="mr-auto" onClick={onHideMiddleware} variant="secondary">{t('Close')}</Button>
            </Modal.Footer>
        </Modal>
    )
}

export default CompanySettings